module.exports = __webpack_public_path__ + "static/media/qbhacks.58ab687d.png";